
export type GetCourseDraftId200 = {
  /** 원본 초안 ID */
  draftId: string;
};
